import { getConfig } from '@configs/envConfig'

export const COPILOT_URL = `${getConfig(process.env.ACKO_ENV)?.copilotUrl}`
